import { render, staticRenderFns } from "./FrameTopBarIcon.vue?vue&type=template&id=5ed043cc&"
import script from "./FrameTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./FrameTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports